// The event colors of Google Calendar, by the colorId it stores on an event.
// An appointment without colorId ('') takes the color of its category.
export const APPOINTMENT_COLORS = [
  { id: '1', hex: '#7986cb', name: { fr: 'Lavande', en: 'Lavender' } },
  { id: '2', hex: '#33b679', name: { fr: 'Sauge', en: 'Sage' } },
  { id: '3', hex: '#8e24aa', name: { fr: 'Raisin', en: 'Grape' } },
  { id: '4', hex: '#e67c73', name: { fr: 'Flamant', en: 'Flamingo' } },
  { id: '5', hex: '#f6bf26', name: { fr: 'Banane', en: 'Banana' } },
  { id: '6', hex: '#f4511e', name: { fr: 'Mandarine', en: 'Tangerine' } },
  { id: '7', hex: '#039be5', name: { fr: 'Paon', en: 'Peacock' } },
  { id: '8', hex: '#616161', name: { fr: 'Graphite', en: 'Graphite' } },
  { id: '9', hex: '#3f51b5', name: { fr: 'Myrtille', en: 'Blueberry' } },
  { id: '10', hex: '#0b8043', name: { fr: 'Basilic', en: 'Basil' } },
  { id: '11', hex: '#d50000', name: { fr: 'Tomate', en: 'Tomato' } },
];

export const DEFAULT_APPOINTMENT_COLOR_ID = '';

// The color of a colorId, or null for '' and an unknown id.
export const appointmentColorOf = (colorId) =>
  APPOINTMENT_COLORS.find((color) => color.id === String(colorId ?? '')) ??
  null;

// `languageCode` is 'fr' or 'en'; any other code reads the English name.
export const appointmentColorName = (color, languageCode) =>
  color ? (languageCode === 'fr' ? color.name.fr : color.name.en) : '';
